import { Injectable, isDevMode } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import * as moment from 'moment';
import 'rxjs/operators';
import { UserService } from '../user-service/user.service';
import { NotificationsDaoService } from 'src/app/dao/notifications-dao-service/notifications-dao.service';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { map } from 'rxjs/internal/operators/map';
import { not } from '@angular/compiler/src/output/output_ast';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  currentMessage = new BehaviorSubject(null);
  notificationsListener = new Subject<any>();
  notifications = []; // Se estan guardando en el servicio pero la idea seria subirlo al server para poder recuperarlo

  accessToken = 'DEV';

  constructor(
    private userService: UserService,
    private userStorageService: UserStorageService,
    private notificationsDaoService: NotificationsDaoService) {
  }

  public notificate(icon, message, touched, action?) {
    const date = moment();
    const notification = { icon, message, touched, action, date };
    this.notifications.push(notification);
    this.notificationsListener.next(this.notifications);
  }

  public notificateReportFinished() {
    this.notificationsListener.next();
  }

  public listenNotifications() {
    return this.notificationsListener.asObservable();
  }

  public isOffline() {
    return new Observable(
      (observable) => {
        window.addEventListener('offline', (offline) => {
          if (offline) {
            observable.next(true);
          }
        });
        window.addEventListener('online', (online) => {
          if (online) {
            observable.next(false);
          }
        });
      }
    );
  }

  // public getLastNotifications() {
  //   console.dir('call notifications/last');
  //   this.getNotifications().pipe(
  //     tap(o => {
  //       const notification = o.filter( n => n.url && n.typeProcess === 'BROADCASTING_ACTITITY').slice(0, 1)[0];
  //       if (notification !== undefined && notification !== null ) {
  //         this.notificate('fas fa-download', notification.message, false, 'window.open("' + notification.url + '");');
  //       }
  //     }),
  //     catchError(error => {
  //       return EMPTY; })
  //   ).subscribe();
  // }

  public getNotifications() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.notificationsDaoService.getLastNotifications(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID()
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          return o['data']['result'];
        })
      );
    }
    return EMPTY;
  }
}
